import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'center',
            gap: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    }
})

export default useStyles
